module.exports = __webpack_public_path__ + "img/icon.3b580217.png";